import { CostBasisMethods } from '@interfaces/models/cost-basis-methods';
import { createSelector } from '@ngrx/store';

import * as fromCostBasis from '../../reducers/cost-basis/cost-basis.reducer';
import * as fromFeature from '../../reducers/index';
import { selectInternalTransferAccountFrom } from '../internal-transfer/internal-transfer.selectors';

export const selectCostBasisState = createSelector(fromFeature.getCostBasis, (state) => state);

export const selectSelectedPositions = createSelector(
  selectCostBasisState,
  fromCostBasis.getSelectedPositions,
);
export const selectCostBasisHoldingsMethod = createSelector(
  selectCostBasisState,
  fromCostBasis.getCostBasisHoldingsMethod,
);
export const selectCostBasisLots = createSelector(
  selectCostBasisState,
  fromCostBasis.getCostBasisLots,
);

export const selectHasHoldingsMethod = (method: CostBasisMethods) =>
  createSelector(selectSelectedPositions, (positions) =>
    positions.some((position) => position.selectedCostBasisMethod === method),
  );

export const selectShowMintaxHoldings = createSelector(
  selectHasHoldingsMethod(CostBasisMethods.MIN_TAX),
  selectInternalTransferAccountFrom,
  (hasMinTax, fromAccount) => hasMinTax && !!fromAccount?.accountData?.managed,
);
